import Vue from 'vue'

import plate from './plate'
import uploadFiles from './uploadFile'
import btnStyle from './btnStyle'
import counter from './counter'
import operateParam from './operateParam'
import sIdentify from './identify'
import empty from './empty/empty'
import normalTable from './normalTable'
import commonBgPlate from './commonBgPlate'
import cardTable from './cardTable'
import detailSection from './detailTable/detailSection'
import detailTable from './detailTable'
import actionBar from './actionBar'
import search from './search'
import downloadDialog from './downloadDialog'
import paramTable from './paramTable'
import instructionBtn from './instructionBtn'
import autoRefresh from './autoRefresh'

Vue.component('plate', plate)
Vue.component('upload-files', uploadFiles)
Vue.component('btnStyle', btnStyle)
Vue.component('counter', counter)
Vue.component('operate-param', operateParam)
Vue.component('s-identify', sIdentify)
Vue.component('empty', empty)
Vue.component('normal-table', normalTable)
Vue.component('common-bg-plate', commonBgPlate)
Vue.component('card-table', cardTable)
Vue.component('detail-section', detailSection)
Vue.component('detail-table', detailTable)
Vue.component('action-bar', actionBar)
Vue.component('search', search)
Vue.component('download-dialog', downloadDialog)
Vue.component('param-table', paramTable)
Vue.component('instruction-btn', instructionBtn)
Vue.component('auto-refresh', autoRefresh)
